<div class="modal-header">
  <h4
    class="modal-title"
    i18n="@@attention"
  >Sitzung beendet</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  ></button>
</div>
<div class="modal-body">
  <p i18n="@@logged-out-notification">Du wurdest ausgeloggt. Falls du ungespeicherte Änderungen hast, sichere sie
    in der Zwischenablage. Lade anschließend die Seite neu und melde dich erneut an.</p>
</div>
<div class="modal-footer">
  <p-button
    label="Zum Login"
    i18n-label="@@go-to-login"
    (onClick)="this.backToLogin()"
  ></p-button>
</div>